var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#3CCF8E"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.038 0 0 4.038 0 9s4.038 9 9 9 9-4.038 9-9-4.038-9-9-9zm0 16.548c-4.162 0-7.55-3.386-7.55-7.548 0-4.164 3.388-7.55 7.55-7.55 4.163 0 7.549 3.388 7.549 7.55S13.163 16.548 9 16.548z",
    transform: "translate(-714 -1018) translate(714 1018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.794 6.206l-4.091 4.09L6.205 8.8c-.275-.275-.723-.275-.998 0-.276.276-.276.723 0 .998l1.997 1.997c.138.137.317.206.499.206.18 0 .36-.07.5-.206l4.59-4.59c.276-.276.276-.721 0-.998-.275-.275-.723-.275-1 0z",
    transform: "translate(-714 -1018) translate(714 1018)"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/v_circle.5c4d3e3a.svg";
export { ForwardRef as ReactComponent };